import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class FablairProductSupport extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('dialog, .shopify-section');
    this.scope?.addEventListener(ThemeEvents.variantUpdate, this.updateSupport);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.updateSupport);
  }

  updateSupport = (event) => {
    const { data } = event.detail || {};
    if (!data?.html) return;
    const currentId = String(this.dataset.productId);
    const sourceId = String(event.target?.dataset?.productId || data.productId || '');
    if (!data.newProduct && sourceId !== currentId) return;
    const next = [...data.html.querySelectorAll('fablair-product-support')].find(
      (element) => element.dataset.blockId === this.dataset.blockId
    );
    if (!next) {
      this.querySelector('.fablair-product-support__inventory')?.replaceChildren();
      return;
    }
    this.dataset.productId = next.dataset.productId;
    morph(this, next, { childrenOnly: true });
  };
}
if (!customElements.get('fablair-product-support')) customElements.define('fablair-product-support', FablairProductSupport);
